import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import * as Sentry from '@sentry/browser';

const httpClient = axios.create();

axios.defaults.headers['Content-Type'] = 'application/json';

const errorComposer = (error: any) => {
  return () => {
    const statusCode = error.response ? error.response.status : null;
    if (statusCode === 404) {
      console.error(
        'The requested resource does not exist or has been deleted',
      );
    } else {
      Sentry.captureException(error);
    }

    if (statusCode === 401) {
      console.error('Please login to access this resource');
    }
  };
};

const interceptHook = (config: AxiosRequestConfig) => {
  return config;
};

const interceptResponseHook = (config: AxiosResponse) => {
  return config;
};

const interceptError = (error: any) => {
  error.handleGlobally = errorComposer(error);
  return Promise.reject(error);
};

httpClient.interceptors.request.use(interceptHook, interceptError);
httpClient.interceptors.response.use(interceptResponseHook, interceptError);

export { httpClient };
